import React, { Component } from "react";
import axios from "axios";
import Layout from "../../Layout/layout";
import { apiHost } from "../../api/apiClient";
import "../../styles/erp/erpAssetMappings.scss";
import RoleAccessBadge from "../common/roleAccessBadge";
import { Link } from "react-router-dom";

class ErpAssetMappings extends Component {
  state = { rows: [], integrations: [], assets: [], vehicles: [], loading: true, error: "", integrationId: "", assetId: "", externalVehicleId: "", isActive: true, saving: false };
  headers = () => ({ Authorization: "Bearer " + localStorage.getItem("token") });

  componentDidMount() { this.load(); }
  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      this.setState(
        { integrationId: "", assetId: "", externalVehicleId: "", vehicles: [] },
        this.load
      );
    }
  }

  customerFilter = () => {
    const params = new URLSearchParams(this.props.location.search);
    return {
      id: params.get("customerId") || "",
      name: params.get("customerName") || "",
    };
  };
  filteredIntegrations = () => {
    const customerId = this.customerFilter().id;
    return customerId
      ? this.state.integrations.filter((item) => String(item.customerId) === String(customerId))
      : this.state.integrations;
  };
  filteredRows = () => {
    const customerId = this.customerFilter().id;
    return customerId
      ? this.state.rows.filter((row) => String(row.customerId) === String(customerId))
      : this.state.rows;
  };

  load = async () => {
    this.setState({ loading: true, error: "" });
    try {
      const customerId = this.customerFilter().id;
      const customerQuery = customerId ? `?customerId=${encodeURIComponent(customerId)}` : "";
      const [rows, options] = await Promise.all([
        axios.get(`${apiHost}/api/admin/erp-asset-mappings${customerQuery}`, { headers: this.headers() }),
        axios.get(`${apiHost}/api/admin/erp-asset-mappings/options${customerQuery}`, { headers: this.headers() })
      ]);
      this.setState({ rows: rows.data || [], integrations: options.data.integrations || [], assets: options.data.assets || [], loading: false });
    } catch (error) { this.setState({ loading: false, error: "ERP asset mappings could not be loaded." }); }
  };

  selectedIntegration = () => this.state.integrations.find((item) => String(item.id) === String(this.state.integrationId));
  eligibleAssets = () => {
    const integration = this.selectedIntegration();
    if (!integration) return [];
    const mappedAssetIds = this.state.rows.filter((row) => String(row.integrationId) === String(integration.id)).map((row) => String(row.assetId));
    return this.state.assets.filter((asset) => String(asset.customerId) === String(integration.customerId) && mappedAssetIds.indexOf(String(asset.id)) === -1);
  };
  normaliseVehicleId = (value) => String(value || "").replace(/[^a-z0-9]/gi, "").toUpperCase();
  eligibleVehicles = () => {
    const mappedIds = this.state.rows
      .filter((row) => String(row.integrationId) === String(this.state.integrationId))
      .map((row) => this.normaliseVehicleId(row.externalVehicleId));
    const seen = [];
    return this.state.vehicles.filter((item) => {
      const value = item.vehicleRegistration || item.truckNo || "";
      const key = this.normaliseVehicleId(value);
      if (!key || mappedIds.indexOf(key) !== -1 || seen.indexOf(key) !== -1) return false;
      seen.push(key);
      return true;
    });
  };

  selectIntegration = async (integrationId) => {
    this.setState({ integrationId, assetId: "", externalVehicleId: "", vehicles: [] });
    if (!integrationId) return;
    try {
      const response = await axios.get(`${apiHost}/api/admin/erp-asset-mappings/vehicles?integrationId=${encodeURIComponent(integrationId)}`, { headers: this.headers() });
      this.setState({ vehicles: response.data || [] });
    } catch (_) { this.setState({ error: "Imported ERP vehicles could not be loaded." }); }
  };

  save = async (event) => {
    event.preventDefault();
    this.setState({ saving: true, error: "" });
    try {
      await axios.post(`${apiHost}/api/admin/erp-asset-mappings`, {
        integrationId: this.state.integrationId, assetId: this.state.assetId,
        externalVehicleId: this.state.externalVehicleId, isActive: this.state.isActive
      }, { headers: this.headers() });
      this.setState({ assetId: "", externalVehicleId: "", isActive: true, saving: false });
      this.load();
    } catch (error) { this.setState({ saving: false, error: (error.response && error.response.data) || "Mapping could not be saved." }); }
  };

  updateRow = (id, field, value) => this.setState(({ rows }) => ({ rows: rows.map((row) => row.id === id ? { ...row, [field]: value } : row) }));
  saveRow = async (row) => {
    try {
      await axios.put(`${apiHost}/api/admin/erp-asset-mappings/${row.id}`, { externalVehicleId: row.externalVehicleId, isActive: row.isActive }, { headers: this.headers() });
      this.load();
    } catch (_) { this.setState({ error: "Mapping changes could not be saved." }); }
  };

  deleteRow = async (row) => {
    if (!window.confirm(`Remove the mapping for ${row.assetName}?`)) return;
    try {
      await axios.delete(`${apiHost}/api/admin/erp-asset-mappings/${row.id}`, { headers: this.headers() });
      this.load();
    } catch (_) { this.setState({ error: "Mapping could not be deleted." }); }
  };

  render() {
    const customerFilter = this.customerFilter();
    const integrations = this.filteredIntegrations();
    const rows = this.filteredRows();
    return <Layout><div className="erp-mapping-page">
      <div className="erp-mapping-title"><div><h1>ERP Asset Mappings</h1><p>Link Visiontrak assets to distinct ERP vehicles seen in imported run sheets during the last 90 days.</p>{customerFilter.id && <Link className="erp-mapping-customer-filter" onClick={() => localStorage.removeItem("customer")} to="/erp-asset-mappings"><i className="fa fa-times"></i>{customerFilter.name || "Filtered customer"}</Link>}</div><RoleAccessBadge role="SystemAdmin" /></div>
      {this.state.error && <div className="erp-mapping-error">{String(this.state.error)}</div>}
      <form className="erp-mapping-form" onSubmit={this.save}>
        <label>ERP integration<select required value={this.state.integrationId} onChange={(e) => this.selectIntegration(e.target.value)}><option value="">{integrations.length ? "Select integration" : "No integrations for this customer"}</option>{integrations.map((item) => <option key={item.id} value={item.id}>{item.customerName} — {item.name} ({item.provider})</option>)}</select></label>
        <label>Visiontrak asset<select required value={this.state.assetId} onChange={(e) => this.setState({ assetId: e.target.value })} disabled={!this.state.integrationId || !this.eligibleAssets().length}><option value="">{this.state.integrationId && !this.eligibleAssets().length ? "All assets are mapped" : "Select remaining asset"}</option>{this.eligibleAssets().map((item) => <option key={item.id} value={item.id}>{item.name}{item.friendlyName ? ` — ${item.friendlyName}` : ""}</option>)}</select></label>
        <label>ERP vehicle<select required value={this.state.externalVehicleId} onChange={(e) => this.setState({ externalVehicleId: e.target.value })} disabled={!this.eligibleVehicles().length}><option value="">{this.state.vehicles.length && !this.eligibleVehicles().length ? "All ERP vehicles are mapped" : this.eligibleVehicles().length ? "Select remaining ERP vehicle" : "No ERP vehicles seen in the last 90 days"}</option>{this.eligibleVehicles().map((item, index) => { const value = item.vehicleRegistration || item.truckNo || ""; const lastSeen = item.lastSeen ? new Date(item.lastSeen).toLocaleDateString("en-AU") : "unknown"; return <option key={`${value}-${item.truckNo}-${index}`} value={value}>{item.vehicleRegistration || "No registration"}{item.truckNo ? ` — Truck ${item.truckNo}` : ""}{item.driver ? ` — ${item.driver}` : ""} — last seen {lastSeen}</option>; })}</select></label>
        <button disabled={this.state.saving}>{this.state.saving ? "Saving…" : "Add mapping"}</button>
      </form>
      <div className="erp-mapping-table-wrap"><table className="erp-mapping-table"><thead><tr><th>Customer</th><th>Integration</th><th>Visiontrak asset</th><th>ERP vehicle</th><th>Active</th><th></th></tr></thead><tbody>
        {this.state.loading ? <tr><td colSpan="6">Loading mappings…</td></tr> : !rows.length ? <tr><td colSpan="6">No ERP asset mappings configured for this customer.</td></tr> : rows.map((row) => <tr key={row.id}><td>{row.customerName}</td><td>{row.integrationName}<small>{row.provider}</small></td><td>{row.assetName}<small>{row.assetFriendlyName}</small></td><td><input value={row.externalVehicleId} onChange={(e) => this.updateRow(row.id, "externalVehicleId", e.target.value)} /></td><td><input type="checkbox" checked={row.isActive} onChange={(e) => this.updateRow(row.id, "isActive", e.target.checked)} /></td><td><div className="erp-mapping-actions"><button onClick={() => this.saveRow(row)}>Save</button><button className="delete" onClick={() => this.deleteRow(row)}>Delete</button></div></td></tr>)}
      </tbody></table></div>
    </div></Layout>;
  }
}

export default ErpAssetMappings;
